module.exports = __webpack_public_path__ + "img/UsSuperMillions_Ad2.1991a4f2.png";